import { Inject, Injectable } from '@angular/core';
import { HttpRequest, HttpHandler, HttpEvent, HttpInterceptor } from '@angular/common/http';
import { Observable } from 'rxjs';

import { UserService } from 'app/_services/user.service';
import { shareReplay } from 'rxjs/operators';

@Injectable()
export class AuthInterceptor implements HttpInterceptor {
    baseUrl = '';
    constructor(private userService: UserService, @Inject('BASE_URL') baseUrl: string) {
        this.baseUrl = baseUrl;
    }

    intercept(request: HttpRequest<any>, next: HttpHandler): Observable<HttpEvent<any>> {
        const authToken = this.userService.User && this.userService.User.authToken;

        let headers = request.headers;

        if (authToken) {
            headers = headers.append('AuthToken', authToken);
        }

        const clonedRequest = request.clone({ headers: headers });

        const result = next.handle(clonedRequest).pipe(shareReplay());

        return result;
    }
}
